// src/app/services/error-handler.service.ts

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})

export class ErrorHandlerService {

  private errorMessages: { [key: number]: string } = {
    1001: 'ERROR.NO_PAYMENTS_LEFT',
    1002: 'ERROR.PAYMENTS_EXPIRED'
  };

  constructor() { }

  getErrorMessage(errorCode: number): string {
    return this.errorMessages[errorCode] || 'ERROR.UNKNOWN_ERROR';
  }
}
